import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

// Same map the backend uses (server.py: _CURRENCY_SYMBOLS)
const SYMBOLS = {
  usd: "$", eur: "€", gbp: "£", cad: "C$", aud: "A$",
  nzd: "NZ$", chf: "CHF", sek: "kr", nok: "kr", dkk: "kr",
  jpy: "¥", inr: "₹", brl: "R$", zar: "R", mxn: "Mex$",
};

/**
 * Single source of truth for the trainer's preferred currency.
 * Reads from auth user; falls back to "usd".
 * Returns:
 *   code:   "gbp" | "usd" | ...
 *   symbol: "£"   | "$"   | ...
 *   format(amount):       "£60.00"
 *   formatSigned(amount): "+£12.00" / "-£5.00"
 */
export function useCurrency() {
  const { user } = useAuth();
  const code = (user?.preferred_currency || "usd").toLowerCase();
  return useMemo(() => {
    const symbol = SYMBOLS[code] || code.toUpperCase() + " ";
    const format = (amount) => `${symbol}${Number(amount || 0).toFixed(2)}`;
    const formatSigned = (amount) => {
      const n = Number(amount || 0);
      return `${n >= 0 ? "+" : "-"}${symbol}${Math.abs(n).toFixed(2)}`;
    };
    return { code, symbol, format, formatSigned };
  }, [code]);
}
